import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class LocalStorageService {
  private storageSub: Subject<{ key: string, data: any }> = new Subject<{ key: string, data: any }>();

  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  setItem(key: string, data: any): void {
    const existingItem = localStorage.getItem(key);
    if (existingItem && existingItem === data) return;

    localStorage.setItem(key, data);
    this.storageSub.next({ key, data });
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
    this.storageSub.next({ key, data: null });
  }
}
